import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  LOCAL_PROMPT_KEY,
  DIRECT_LOGIN,
  loadStorageItem
} from '@/utils/storage'
import * as type from './types'

export default {
  error: {},

  [type.DICTIONARY]: {
    /**
     * {
     *   key: 'ключ в словаре i18n',
     *   value: 'значение сервера'
     * }
     */
    dateRangeArray: [
      { key: 'c.select.dateRangeAllTime', value: 'ALL_TIME' },
      { key: 'c.select.dateRangeToday', value: 'TODAY' },
      { key: 'c.select.dateRangeYesterday', value: 'YESTERDAY' },
      { key: 'c.select.dateRangeThisWeek', value: 'THIS_WEEK_MON_TODAY' },
      { key: 'c.select.dateRangeLast7Days', value: 'LAST_7_DAYS' },
      { key: 'c.select.dateRangeThisMonth', value: 'THIS_MONTH' },
      { key: 'c.select.dateRangeLast30Days', value: 'LAST_30_DAYS' },
      { key: 'c.select.dateRangeOtherRange', value: 'OTHER_RANGE' }
    ],
    adGroupTypes: [
      { key: 'c.select.adGroupTypeSearch', value: 'SEARCH' },
      { key: 'c.select.adGroupTypeDisplayNetwork', value: 'CMS' },
      { key: 'c.select.adGroupTypeYouTubeSearch', value: 'YSEARCH' },
      { key: 'c.select.adGroupTypeYouTubeVideo', value: 'VIDEOS' },
      { key: 'c.select.adGroupTypeCrossNetwork', value: 'CROSS' }
    ],
    blacklistLevels: [
      { key: 'c.select.rangeBlackListAll', value: 'all', type: 'all' },
      { key: 'c.select.rangeBlackListAccount', value: 'account', type: 'account' }
    ]
  },

  [type.COMMON]: {
    loading: false,
    loadingPromises: {},
    loadingMessage: '',
    locale: null
  },

  [type.NOTIFICATIONS]: {
    list: []
  },

  [type.SUMMARY]: {
    loading: false,
    model: {
      createdAt: '2019-06-04',
      isConversionsSyncValid: true,
      placements: {
        best: {
          count: 0
        },
        disputable: {
          cost: 0,
          count: 0
        },
        worst: {
          cost: 0,
          count: 0
        }
      },
      keywords: {
        best: {
          totalCount: 0
        },
        disputable: {
          totalCount: 0,
          totalConversions: 0,
          costs: 0
        },
        worst: {
          totalCount: 0,
          totalConversions: 0,
          costs: 0
        }
      },
      ads: {
        best: {
          totalCount: 0
        },
        disputable: {
          totalCount: 0,
          totalConversions: 0,
          costs: 0
        },
        worst: {
          totalCount: 0,
          totalConversions: 0,
          costs: 0
        }
      }
    }
  },

  [type.SESSION]: {
    loading: false,
    prompt: loadStorageItem(LOCAL_PROMPT_KEY),
    model: {
      access: loadStorageItem(ACCESS_TOKEN),
      refresh: loadStorageItem(REFRESH_TOKEN),
      id: null,
      user: {
        userId: null,
        directLogin: loadStorageItem(DIRECT_LOGIN),
        directDataUpdatedAt: null,
        email: null,
        username: null,
        accountAvgCpls: {}
      },
      currentlyViewProfile: null,
      firstLogin: false,
      authorities: [],
      accounts: []
    }
  },

  [type.CAMPAIGNS]: {
    loading: false,
    list: []
  },

  // placements
  [type.GENERAL_CONFIGURATION]: {
    conversionsSyncDate: null
  },

  [type.WORST_PLACEMENTS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      hasActiveCampaigns: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 20,
      currentPage: 1,
      totalPage: null,
      count: 0
    }
  },

  [type.DISPUTED_PLACEMENTS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      hasActiveCampaigns: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 20,
      currentPage: 1,
      totalPage: null,
      count: 0
    }
  },

  [type.BEST_PLACEMENTS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      hasActiveCampaigns: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 20,
      currentPage: 1,
      totalPage: null,
      count: 0
    }
  },

  [type.BLACKLIST_PLACEMENTS]: {
    loading: false,
    list: [],
    params: {
      level: null,
      sort: {
        prop: null,
        order: null
      },
      limit: 50,
      currentPage: 1,
      totalPage: null
    }
  },

  [type.WHITELIST_PLACEMENTS]: {
    loading: false,
    list: [],
    params: {
      sort: {
        prop: null,
        order: null
      },
      limit: 50,
      currentPage: 1,
      totalPage: null
    }
  },
  // end placements

  // key words
  [type.WORST_KEYWORDS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    },
    cpl: {}
  },

  [type.DISPUTED_KEYWORDS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    },
    cpl: {}
  },

  [type.BEST_KEYWORDS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    },
    cpl: {}
  },

  [type.EXCEPTION_KEYWORDS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
  },
  // end key words

  // ad groups
  [type.WORST_ADS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      filterType: null,
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    },
    cpl: {}
  },

  [type.DISPUTED_ADS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      filterType: null,
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    },
    cpl: {}
  },

  [type.EXCEPTION_ADS]: {
    loading: false,
    list: [],
    params: {
      isValidConversions: true,
      dateRange: null,
      customDateRange: [],
      filterType: null,
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
  },
  // end ad groups

  // action log list
  [type.ACTION_LOG]: {
    loading: false,
    list: [],
    params: {
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
  },
  // end action log

  // action log placements
  [type.ACTION_LOG_PLACEMENTS]: {
    loading: false,
    list: [],
    model: {
      id: null,
      type: null
    },
    params: {
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
  },
  // end action log placements

  // action log keywords
  [type.ACTION_LOG_KEYWORDS]: {
    loading: false,
    list: [],
    model: {
      id: null,
      type: null
    },
    params: {
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
  },
  // end action log keywords

  // action log ads
  [type.ACTION_LOG_ADS]: {
    loading: false,
    list: [],
    model: {
      id: null,
      type: null
    },
    params: {
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
  },
  // end action log ads

  [type.ACCOUNT_SETTINGS]: {
    loading: false,
    model: {
      accountId: 0,
      directLogin: '',
      hasPerformanceClassification: false,
      hasGlobalBlacklistClassification: false,
      hasDnsClassification: false,
      hasCtrClassification: false,
      hasMaskClassification: false,
      directDataUpdatedAt: '',
      currencyCode: '',
      hasJunkNotificationLimit: false,
      junkNotificationLimit: 0,
      hasEnableNotifications: false,
      conversionsSyncDate: '',
      hasPlacementsAutodisable: false,
      hasNetworksBanned: false,
      isFirstBan: false,
      masks: [],
      emailList: []
    }
  }
}
